// extracted by mini-css-extract-plugin
export default {"anchor":"SideActionsCard_anchor__p5bns"};